var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('div',{staticClass:"not-yet"},[_c('h2',{staticClass:"not-yet__title"},[_vm._v("not "+_vm._s(_vm.nameStatus)+" yet")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }